import type { QueryClient } from '@tanstack/react-query';
import type { RegisteredRouter } from '@tanstack/react-router';
import type { ImportQueueListFilters } from '../queries';
import { importQueueKey, listImportQueueOptions } from '../queries';

export async function navigateToNextImportItem(
  qc: QueryClient,
  router: RegisteredRouter,
  currentMessageId: string,
  listFilters: ImportQueueListFilters = { status: 'EXTRACTED' },
): Promise<void> {
  await qc.invalidateQueries({ queryKey: [...importQueueKey, 'list'] });
  const list = await qc.fetchQuery(listImportQueueOptions(listFilters));
  const items = list.items;
  if (items.length === 0) {
    await router.navigate({ to: '/import-queue' });
    return;
  }
  const idx = items.findIndex((i) => i.id === currentMessageId);
  const next = idx >= 0 ? items[idx + 1] : items[0];
  const target = next ?? items[0];
  if (!target || target.id === currentMessageId) {
    await router.navigate({ to: '/import-queue' });
    return;
  }
  await router.navigate({ to: '/import-queue/$messageId', params: { messageId: target.id } });
}
